<template>
  <div>
    <!-- <ConsultAdd
      :is-add-new-consult-sidebar-active.sync="isAddNewConsultSidebarActive"
      @createConsult="createConsult"
    /> -->
    <b-sidebar
      id="add-new-appointment-sidebar"
      :visible="isAddNewAppointmentSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      right
      z-index="1300"
      @hidden="resetForm"
      @change="val => $emit('update:is-add-new-appointment-sidebar-active', val)">
      <template #default="{ hide }">
        <!-- Header -->
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">Add New Appointment</h5>

          <i class="fas fa-times ml-1 cursor-pointer" size="16" @click="hide"></i>
        </div>

        <!-- BODY -->
        <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
          <!-- Form -->
          <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm">
            <validation-provider
              #default="validationContext"
              name="Patient"
              rules="required">
              <b-form-group :label="$t('Patient')" label-for="patient">
                <b-form-input
                  disabled
                  :value="`${userAppointment.name} ${userAppointment.lastname}`" />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- City: input + lista automática debajo (sin clic en select) -->
            <validation-provider
              #default="validationContext"
              name="City"
              rules="required">
              <b-form-group
                :label="$t('Form.City')"
                label-for="city-appointment"
                class="city-autocomplete-wrap">
                <b-form-input
                  id="city-appointment"
                  v-model="cityName"
                  :state="getValidationState(validationContext)"
                  placeholder="Enter city name"
                  @input="searchCitiesFromInput"
                  @focus="cityName && searchCitiesFromInput()" />
                <div v-if="cityOptions.length" class="city-options-list">
                  <div
                    v-for="opt in cityOptions"
                    :key="opt.value"
                    class="city-option-item"
                    @mousedown.prevent="selectCityOption(opt)">
                    {{ opt.text }}
                  </div>
                </div>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- Zip Code -->
            <validation-provider
              #default="validationContext"
              name="Zip Code"
              rules="required">
              <b-form-group label="Zip Code" label-for="zip-code-appointment">
                <b-form-input
                  id="zip-code-appointment"
                  v-model="stateData.zip_codes_id"
                  :state="getValidationState(validationContext)"
                  type="number"
                  placeholder="Enter zip code" />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="Insurance Agent"
              rules="required">
              <b-form-group label-for="agent_insurance">
                <label for="agent_insurance">
                  {{ $t('Insurance Agent') }}
                  <span class="text-danger">*</span>
                  <small class="text-muted">({{ $t('Required') }})</small>
                </label>
                <treeselect
                  id="agent_insurance"
                  v-model="stateData.agent_insurance_id"
                  :state="getValidationState(validationContext)"
                  :options="optionsAgentInsurance"
                  :normalizer="normalizer"
                  placeholder="Select agent"
                  @input="() => { validationContext.touched = true; validationContext.validate(); }"
                  @open="() => { validationContext.touched = true; }"
                  @blur="() => { validationContext.touched = true; validationContext.validate(); }" />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="Type Visit"
              rules="required">
              <b-form-group :label="$t('Types of visits')" label-for="type visit">
                <!-- <v-select
                  id="type visit"
                  v-model="stateData.typeVisit"
                  :state="getValidationState(validationContext)"
                  :options="optionsTypeVisit"
                  @search="searchTypeVisit"
                  :reduce="(option) => option.id"
                  :clearable="false"
                  label="name"
                /> -->
                <treeselect
                  id="type_consult"
                  v-model="stateData.typeVisit"
                  :state="getValidationState(validationContext)"
                  :options="optionsTypeVisit"
                  :normalizer="normalizer" />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="Visit reason"
              rules="required">
              <b-form-group label-for="visit_reason">
                <label for="visit_reason">{{ $t('Visit Reason') }}</label>
                <treeselect
                  id="visit_reason"
                  v-model="stateData.reason_visit"
                  :options="visitReasonOptions"
                  :normalizer="normalizer"
                  :searchable="true"
                  :clearable="true"
                  :multiple="false"
                  placeholder="Select a visit reason"
                  :max-height="200"
                  :options-limit="50"
                  :class="{
                    'custom-treeselect': true,
                    'is-invalid': validationContext.touched && !validationContext.valid
                  }" />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- Other Reason Input (conditional) -->
            <validation-provider
              v-if="showOtherReasonInput"
              #default="validationContext"
              name="Other Reason"
              rules="required">
              <b-form-group label-for="reason_visit_other">
                <label for="reason_visit_other">{{ $t('Please specify') }}</label>
                <b-form-textarea
                  id="reason_visit_other"
                  v-model="stateData.reason_visit_other"
                  :state="getValidationState(validationContext)"
                  placeholder="Please specify the reason for your visit"
                  rows="3" />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <b-button
              v-if="isNewConsultation"
              class="my-4"
              type="button"
              variant="primary"
              @click="IsInsuranceMetod">
              Change Insurance
            </b-button>

            <div v-if="isInsurance && isNewConsultation">
              <p class="text-danger text-lg font-weight-bold">
                Please remember to fill in all fields when enabling this option.
              </p>

              <validation-provider
                #default="validationContext"
                name="Name Insurance"
                rules="required">
                <b-form-group label-for="name_insurance">
                  <label for="name_insurance">
                    {{ $t('Name insurance') }}
                    <span class="text-danger">*</span>
                    <small class="text-muted">({{ $t('Required') }})</small>
                  </label>
                  <treeselect
                    id="name_insurance"
                    v-model="stateData.nameInsuranceId"
                    :state="getValidationState(validationContext)"
                    :options="optionsNameInsurance"
                    :normalizer="normalizer"
                    placeholder="Select insurance" />
                  <b-form-invalid-feedback>{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <validation-provider
                #default="validationContext"
                name="Member ID"
                rules="required|max:255">
                <b-form-group label-for="member_id">
                  <label for="member_id">
                    Member ID
                    <span class="text-danger">*</span>
                    <small class="text-muted">({{ $t('Required') }})</small>
                  </label>
                  <b-form-input
                    id="member_id"
                    v-model="stateData.member_id"
                    :state="getValidationState(validationContext)"
                    trim
                    :maxlength="memberIdMaxLength"
                    placeholder="Enter member identifier" />
                  <div class="d-flex justify-content-between mt-1">
                    <small class="text-muted">
                      {{ memberIdLength }} / {{ memberIdMaxLength }}
                    </small>
                    <small class="text-muted">
                      {{ memberIdRemaining }}
                      {{ memberIdRemaining === 1 ? 'character left' : 'characters left' }}
                    </small>
                  </div>
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <validation-provider
                #default="validationContext"
                name="Copay"
                rules="required">
                <b-form-group label-for="copay">
                  <label for="copay">
                    {{ $t('Copay') }}
                    <span class="text-danger">*</span>
                    <small class="text-muted">({{ $t('Required') }})</small>
                  </label>
                  <b-form-input
                    id="copay"
                    v-model="stateData.copay"
                    type="number"
                    :state="getValidationState(validationContext)"
                    trim
                    placeholder="Copay"
                    min="0" />
                  <b-form-invalid-feedback>{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <validation-provider
                #default="validationContext"
                name="Co Insurance"
                rules="required">
                <b-form-group label-for="co_insurance">
                  <label for="co_insurance">
                    {{ $t('CoInsurance') }}
                    <span class="text-danger">*</span>
                    <small class="text-muted">({{ $t('Required') }})</small>
                  </label>
                  <b-form-input
                    id="co_insurance"
                    v-model="stateData.co_insurance"
                    type="number"
                    :state="getValidationState(validationContext)"
                    trim
                    placeholder="Co Insurance"
                    min="0" />
                  <b-form-invalid-feedback>{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <validation-provider
                #default="validationContext"
                name="Deducible"
                rules="required">
                <b-form-group label-for="deducible">
                  <label for="deducible">
                    {{ $t('Deducible') }}
                    <span class="text-danger">*</span>
                    <small class="text-muted">({{ $t('Required') }})</small>
                  </label>
                  <b-form-input
                    id="deducible"
                    v-model="stateData.deducible"
                    type="number"
                    :state="getValidationState(validationContext)"
                    trim
                    placeholder="Deducible"
                    min="0" />
                  <b-form-invalid-feedback>{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <validation-provider
                #default="validationContext"
                name="Out Pocket"
                rules="required">
                <b-form-group label-for="out_pocket">
                  <label for="out_pocket">
                    {{ $t('OutPocket') }}
                    <span class="text-danger">*</span>
                    <small class="text-muted">({{ $t('Required') }})</small>
                  </label>
                  <b-form-input
                    id="out_pocket"
                    v-model="stateData.out_pocket"
                    type="number"
                    :state="getValidationState(validationContext)"
                    trim
                    placeholder="Out Pocket"
                    min="0" />
                  <b-form-invalid-feedback>{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </div>

            <validation-provider
              v-show="checkCodeQr"
              #default="validationContext"
              name="Qr">
              <b-form-group label="Qr" label-for="Qr">
                <b-form-input
                  id="Qr"
                  v-model="stateData.codeQr"
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Code qr" />
              </b-form-group>

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>

            <checkCupon :cupon.sync="stateData.cupon" @cancelCupon="cancelCupon" />

            <membershipPerUser
              v-if="stateData.typeVisit == 8"
              :id_user="userAppointment.id"
              :membership.sync="stateData.membership_id" />

            <validation-provider
              v-if="stateData.typeVisit == 2 || stateData.typeVisit == 8 || stateData.typeVisit == 13 || stateData.typeVisit == 14"
              #default="validationContext"
              name="reference"
              rules="required">
              <b-form-group label-for="reference">
                <label for="reference">{{ $t('Reference') }}</label>
                <treeselect
                  id="reference"
                  v-model="stateData.user_references_id"
                  :state="getValidationState(validationContext)"
                  :options="optionsReferenceList"
                  :normalizer="normalizer" />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- <b-button
              @click="scanPromotion"
              :variant="checkCodeQr ? 'primary' : 'outline-primary'"
            >
              Scan QR
            </b-button> -->

            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button variant="primary" class="mr-1" type="submit" :disabled="loading">
                <span v-if="!loading">{{ $t('Add') }}</span>
                <span v-else>
                  <SpinnerLoading />
                </span>
              </b-button>
              <b-button type="button" variant="outline-danger" @click="hide">
                {{ $t('Cancel') }}
              </b-button>
            </div>
            <!-- <div v-if="showConfirmation" class="mt-2">
              <b-alert show variant="warning" class="mb-2">
                {{ confirmationMessage }}
              </b-alert>
              <div class="d-flex">
                <b-button variant="primary" class="mr-1" type="button" :disabled="loading" @click="confirmSave">
                  <span v-if="!loading">{{ $t('Save') }}</span>
                  <span v-else>
                    <SpinnerLoading />
                  </span>
                </b-button>
                <b-button type="button" variant="outline-danger" :disabled="loading" @click="cancelConfirmation">
                  {{ $t('Cancel') }}
                </b-button>
              </div>
            </div> -->
          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
    <ToastNotification ref="toast" />
  </div>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BAlert,
} from 'bootstrap-vue'
import formValidation from '@/core/utils/forms/form-validation'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastNotification from '@/components/ToastNotification'
import checkCupon from '@/components/checkCupon'
import { notificationCheck } from '@/mixins/NotificationSetup'

import SpinnerLoading from '@/components/SpinnerLoading'

import flatPickr from 'vue-flatpickr-component'

import { required } from '@validations'
import { computed, onMounted, ref, watch } from '@vue/composition-api'

import axiosA from '@/core/services/apiInsurance/appointment'
import axiosAC from '@/core/services/apiInsurance/appointment/actions'
import axiosTV from '@/core/services/apiInsurance/admin/consults/visits'
import axiosC from '@/core/services/apiInsurance/admin/consults/consults'
import axiosP from '@/core/services/apiInsurance/patient'
import axiosCities from '@/core/services/apiInsurance/admin/cities'
import membershipPerUser from '../../../../components/membershipPerUser.vue'
import axiosNI from '@/core/services/apiInsurance/admin/consults/insuranceName'
/* import ConsultAdd from "@/views/admin/type-consult/consult/ConsultAdd"; */

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BAlert,
    // BInputGroup,
    // BInputGroupAppend,
    SpinnerLoading,
    // flatPickr,
    ToastNotification,
    checkCupon,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
    membershipPerUser,
  },
  model: {
    prop: 'isAddNewAppointmentSidebarActive',
    event: 'update:is-add-new-appointment-sidebar-active',
  },
  props: {
    isAddNewAppointmentSidebarActive: {
      type: Boolean,
      required: true,
    },
    userAppointment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visitReasonOptions: [
        { id: 'Other', name: 'Other' },
        { id: 'Abdominal Pain', name: 'Abdominal Pain' },
        { id: 'Allergies', name: 'Allergies' },
        { id: 'Anxiety', name: 'Anxiety' },
        { id: 'Back Pain', name: 'Back Pain' },
        { id: 'Breast Pain', name: 'Breast Pain' },
        { id: 'Chest Pain', name: 'Chest Pain' },
        { id: 'Cold Symptoms', name: 'Cold Symptoms' },
        { id: 'Consultation', name: 'Consultation' },
        { id: 'Cough', name: 'Cough' },
        { id: 'COVID', name: 'COVID' },
        { id: 'Dermatitis', name: 'Dermatitis' },
        { id: 'Diabetes', name: 'Diabetes' },
        { id: 'Diarrhea', name: 'Diarrhea' },
        { id: 'DIU Removal', name: 'DIU Removal' },
        { id: 'Dizziness', name: 'Dizziness' },
        { id: 'DM Control', name: 'DM Control' },
        { id: 'Earache', name: 'Earache' },
        { id: 'Exams', name: 'Exams' },
        { id: 'Fever', name: 'Fever' },
        { id: 'Flu', name: 'Flu' },
        { id: 'Follow Up', name: 'Follow Up' },
        { id: 'General Check', name: 'General Check' },
        { id: 'General Exam', name: 'General Exam' },
        { id: 'Headache', name: 'Headache' },
        { id: 'Health Checkup', name: 'Health Checkup' },
        { id: 'HTN Control', name: 'HTN Control' },
        { id: 'Ingrown Toe Nail', name: 'Ingrown Toe Nail' },
        { id: 'Injection', name: 'Injection' },
        { id: 'IV Therapy', name: 'IV Therapy' },
        { id: 'Knee Pain', name: 'Knee Pain' },
        { id: 'Lab Result', name: 'Lab Result' },
        { id: 'Lower Back Pain', name: 'Lower Back Pain' },
        { id: 'Menstrual Disorder', name: 'Menstrual Disorder' },
        { id: 'Pending Injection', name: 'Pending Injection' },
        { id: 'Physical School', name: 'Physical School' },
        { id: 'Pregnancy Test', name: 'Pregnancy Test' },
        { id: 'Rash', name: 'Rash' },
        { id: 'Refill', name: 'Refill' },
        { id: 'Respiratory Disorder', name: 'Respiratory Disorder' },
        { id: 'Result', name: 'Result' },
        { id: 'Semaglutide', name: 'Semaglutide' },
        { id: 'Shoulder pain', name: 'Shoulder pain' },
        { id: 'Skin Lesion', name: 'Skin Lesion' },
        { id: 'Sore Throat', name: 'Sore Throat' },
        { id: 'Stomachache', name: 'Stomachache' },
        { id: 'USG', name: 'USG' },
        { id: 'Vitamin pack', name: 'Vitamin pack' },
        { id: 'X Ray', name: 'X Ray' },
      ],
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
    }
  },
  setup(props, { emit }) {
    const isAddNewConsultSidebarActive = ref(false)
    const isInsurance = ref(false)
    const stateDataTem = {
      reason_visit: null,
      reason_visit_other: '',
      userType: '',
      patient: null,
      typeVisit: null,
      typeConsultation: null,
      scanQr: null,
      cupon: '',
      membership_id: null,
      user_references_id: null,
      nameInsuranceId: null,
      type_insurance: null,
      copay: 0,
      co_insurance: 0,
      deducible: 0,
      out_pocket: 0,
      agent_insurance_id: null,
      member_id: '',
      cities_id: null,
      zip_codes_id: null,
    }
    const optionsNameInsurance = ref([])
    const optionsAgentInsurance = ref([])
    const memberIdMaxLength = 255
    const stateData = ref(JSON.parse(JSON.stringify(stateDataTem)))
    const showConfirmation = ref(false)
    const pendingAppointment = ref(null)
    const cityName = ref('')
    const cityOptions = ref([])
    const setTimeoutCitySearch = ref(null)

    const resetstateData = () => {
      stateData.value = JSON.parse(JSON.stringify(stateDataTem))
      cityName.value = ''
      cityOptions.value = []
      setAgentFromPatient(props.userAppointment || {})
      showConfirmation.value = false
      pendingAppointment.value = null
    }

    const checkCodeQr = ref(false)
    const toast = ref(null)

    watch(
      () => props.userAppointment,
      (patient) => {
        if (!patient || !patient.id) {
          cityName.value = ''
          cityOptions.value = []
          stateData.value.cities_id = null
          stateData.value.zip_codes_id = null
          return
        }
        stateData.value.zip_codes_id = patient.zip_codes_id ?? null
        if (patient.cities && patient.cities.name) {
          cityName.value = patient.cities.name
          cityOptions.value = [{ text: patient.cities.name, value: patient.cities.id }]
          stateData.value.cities_id = patient.cities_id
        } else {
          cityName.value = ''
          cityOptions.value = []
          axiosP.patientDetail(patient.id).then((response) => {
            const registro = response?.registro ?? response
            if (registro?.cities) {
              cityName.value = registro.cities.name || ''
              cityOptions.value = [{ text: registro.cities.name, value: registro.cities.id }]
              stateData.value.cities_id = registro.cities_id ?? registro.cities.id
            } else if (registro?.cities_id) {
              stateData.value.cities_id = registro.cities_id
            }
            if (registro?.zip_codes_id != null) {
              stateData.value.zip_codes_id = registro.zip_codes_id
            }
          }).catch(() => {})
        }
      },
      { immediate: true }
    )

    const searchCitiesFromInput = () => {
      if (!cityName.value || !cityName.value.length) {
        cityOptions.value = []
        return
      }
      clearTimeout(setTimeoutCitySearch.value)
      setTimeoutCitySearch.value = setTimeout(() => {
        axiosCities
          .citiesFilterFilters({ name: cityName.value })
          .then((response) => {
            const list = Array.isArray(response) ? response : (response && response.data) || []
            cityOptions.value = (list || []).map(city => ({
              text: city.name,
              value: city.id,
            }))
          })
          .catch(() => {
            cityOptions.value = []
          })
      }, 350)
    }

    const onCitySelect = () => {
      const selected = cityOptions.value.find(opt => opt.value === stateData.value.cities_id)
      if (selected) cityName.value = selected.text
    }

    const selectCityOption = (opt) => {
      stateData.value.cities_id = opt.value
      cityName.value = opt.text
      cityOptions.value = []
    }

    watch(
      () => stateData.value.codeQr,
      (newValue, oldValue) => {
        if (newValue !== null || newValue.length > 0) {
          const data = {
            codeQr: stateData.value.codeQr,
          }
          axiosAC.appointmentAssignCuppon(data).then(res => {
            const { type, message } = notificationCheck(res)
            toast.value[type](message)
          })
        }
      }
    )

    watch(
      () => stateData.value.reason_visit,
      () => {
        clearOtherReason()
      }
    )

    watch(
      () => stateData.value,
      () => {
        if (showConfirmation.value) {
          showConfirmation.value = false
          pendingAppointment.value = null
        }
      },
      { deep: true }
    )

    const setAgentFromPatient = patient => {
      // Console log para ver la información del paciente
      console.log('=== Información del Paciente ===')
      console.log('Paciente completo:', patient)
      console.log('name_insurance:', patient?.name_insurance)
      console.log('nameInsuranceId:', patient?.name_insurance?.id || patient?.nameInsuranceId)
      console.log('copay:', patient?.copay)
      console.log('co_insurance:', patient?.co_insurance)
      console.log('deducible:', patient?.deducible)
      console.log('out_pocket:', patient?.out_pocket)
      console.log('================================')

      const agentId =
        patient?.agent_insurance_id ??
        patient?.agentInsuranceId ??
        patient?.agent_insurance?.id ??
        patient?.agent?.id ??
        null
      stateData.value.agent_insurance_id = agentId

      // Cargar datos del insurance del paciente si existen
      if (patient) {
        // Cargar nameInsuranceId
        const insuranceId =
          patient?.name_insurance?.id ??
          patient?.nameInsuranceId ??
          patient?.name_insurance_id ??
          null
        if (insuranceId) {
          stateData.value.nameInsuranceId = insuranceId
        }

        // Cargar copay
        if (patient?.copay !== undefined && patient?.copay !== null) {
          stateData.value.copay = Number(patient.copay) || 0
        }

        // Cargar co_insurance
        if (patient?.co_insurance !== undefined && patient?.co_insurance !== null) {
          stateData.value.co_insurance = Number(patient.co_insurance) || 0
        }

        // Cargar deducible
        if (patient?.deducible !== undefined && patient?.deducible !== null) {
          stateData.value.deducible = Number(patient.deducible) || 0
        }

        // Cargar out_pocket
        if (patient?.out_pocket !== undefined && patient?.out_pocket !== null) {
          stateData.value.out_pocket = Number(patient.out_pocket) || 0
        }
      }
    }

    watch(
      () => props.userAppointment,
      newPatient => {
        setAgentFromPatient(newPatient || {})
      },
      { immediate: true }
    )

    // Watch para cargar datos cuando se abre el modal
    watch(
      () => props.isAddNewAppointmentSidebarActive,
      isOpen => {
        if (isOpen && props.userAppointment) {
          // Cuando se abre el modal, asegurarse de cargar los datos del paciente
          setAgentFromPatient(props.userAppointment || {})
        }
      }
    )

    const scanPromotion = () => {
      if (checkCodeQr.value) {
        stateData.value.codeQr = null
      }
      checkCodeQr.value = !checkCodeQr.value
    }

    const createConsult = () => {
      loadTypeConsult()
      isAddNewConsultSidebarActive.value = false
    }

    const IsInsuranceMetod = () => {
      isInsurance.value = !isInsurance.value
    }

    const showOtherReasonInput = computed(() => {
      return stateData.value.reason_visit === 'Other'
    })

    const optionsTypeVisit = ref([])
    const optionsTypeConsult = ref([])
    const clearTimeoutBuscador = ref('')
    const optionsReferenceList = ref([])
    const patientFullName = computed(() => {
      return [props.userAppointment?.name, props.userAppointment?.lastname]
        .filter(Boolean)
        .join(' ')
        .trim()
    })
    const selectedAgentName = computed(() => {
      const agent = optionsAgentInsurance.value.find(
        option => option.id === stateData.value.agent_insurance_id
      )
      if (agent?.name) return agent.name

      const patient = props.userAppointment || {}
      const fallbackName = [
        patient?.agent_insurance?.name || patient?.agent?.name || patient?.agent_name,
        patient?.agent_insurance?.lastname ||
          patient?.agent?.lastname ||
          patient?.agent_lastname,
      ]
        .filter(Boolean)
        .join(' ')
        .trim()
      return fallbackName
    })
    const selectedTypeVisit = computed(() =>
      optionsTypeVisit.value.find(option => option.id === stateData.value.typeVisit)
    )
    const isNewConsultation = computed(() => {
      const visit = selectedTypeVisit.value
      if (!visit) return false

      const name = (visit.name || visit.label || '').toString().toLowerCase()
      // Debe aparecer con todos los tipos de visita que contengan "insurance"
      return name.includes('insurance')
    })
    const confirmationMessage = computed(() => {
      const patientName = patientFullName.value || 'this patient'
      const agentName = selectedAgentName.value || 'the selected agent'
      return `Are you sure you want to save patient ${patientName} with agent ${agentName}?`
    })

    const memberIdLength = computed(() => (stateData.value.member_id || '').length)

    const memberIdRemaining = computed(
      () => memberIdMaxLength - memberIdLength.value
    )

    watch(
      isNewConsultation,
      value => {
        if (value) {
          isInsurance.value = true
          // Si el paciente ya tiene datos de insurance cargados, mantenerlos
          // Solo resetear si no hay datos del paciente
          if (!props.userAppointment?.nameInsuranceId && !props.userAppointment?.name_insurance?.id) {
            // Si no hay datos del paciente, mantener los valores actuales o resetear solo si están vacíos
            if (!stateData.value.nameInsuranceId) {
              stateData.value.nameInsuranceId = null
            }
            if (!stateData.value.copay && stateData.value.copay !== 0) {
              stateData.value.copay = 0
            }
            if (!stateData.value.co_insurance && stateData.value.co_insurance !== 0) {
              stateData.value.co_insurance = 0
            }
            if (!stateData.value.deducible && stateData.value.deducible !== 0) {
              stateData.value.deducible = 0
            }
            if (!stateData.value.out_pocket && stateData.value.out_pocket !== 0) {
              stateData.value.out_pocket = 0
            }
          }
        } else {
          isInsurance.value = false
          // Solo resetear si el paciente no tiene datos de insurance
          // Si el paciente tiene datos, mantenerlos para cuando se vuelva a activar
          if (!props.userAppointment?.nameInsuranceId && !props.userAppointment?.name_insurance?.id) {
            stateData.value.nameInsuranceId = null
            stateData.value.copay = 0
            stateData.value.co_insurance = 0
            stateData.value.deducible = 0
            stateData.value.out_pocket = 0
          }
        }
      },
      { immediate: true }
    )

    onMounted(() => {
      loadTypeVisit()
      loadTypeConsult()
      loadReferencesList()
      loadNameInsurance()
      loadInsuranceAgents()
    })

    const loadNameInsurance = () => {
      axiosNI
        .visitList(20)
        .then(({ data }) => {
          optionsNameInsurance.value = data
        })
        .catch(err => {
          console.error('Error loading name insurance:', err)
        })
    }
    const loadInsuranceAgents = () => {
      axiosP
        .getInsuranceAgents()
        .then(response => {
          let rawAgents = []

          if (Array.isArray(response?.data?.data)) {
            rawAgents = response.data.data
          } else if (Array.isArray(response?.data)) {
            rawAgents = response.data
          } else if (Array.isArray(response)) {
            rawAgents = response
          }

          optionsAgentInsurance.value = rawAgents.map(agent => {
            const fullName = [agent?.name, agent?.lastname].filter(Boolean).join(' ').trim()
            return {
              id: agent?.id,
              name: fullName || agent?.name || agent?.lastname || '',
            }
          })
        })
        .catch(error => {
          console.log(error)
          optionsAgentInsurance.value = []
        })
    }

    /**
     * Filtra los tipos de visita para mostrar solo los relacionados con insurance
     * Incluye tipos que contengan "insurance" en el nombre y "all"/"todos" si existen
     */
    const filterInsuranceVisitTypes = visitTypes => {
      if (!Array.isArray(visitTypes)) return []
      return visitTypes.filter(visit => {
        const name = (visit.name || '').toString().toLowerCase()
        // Incluir tipos que contengan "insurance" o sean "all"/"todos"
        return name.includes('insurance') || name === 'all' || name === 'todos'
      })
    }

    const loadTypeVisit = () => {
      axiosTV.visitList(20).then(({ data }) => {
        const findItem = data.findIndex(item => item.id === 3)
        if (findItem !== -1) {
          data.splice(findItem, 1)
        }
        // Filtrar solo tipos de visita relacionados con insurance
        optionsTypeVisit.value = filterInsuranceVisitTypes(data)
      })
    }
    const loadTypeConsult = () => {
      axiosC.consultList(10).then(({ data }) => {
        optionsTypeConsult.value = data
      })
    }
    const searchTypeVisit = (name, loading) => {
      if (name.length) {
        const datos = {
          name,
        }
        loading(true)
        clearTimeout(clearTimeoutBuscador.value)
        clearTimeoutBuscador.value = setTimeout(() => {
          axiosTV.visitFilter(20, datos).then(({ registro: { data } }) => {
            loading(false)
            const findItem = data.findIndex(item => item.id === 3)
            if (findItem !== -1) {
              data.splice(findItem, 1)
            }
            // Filtrar solo tipos de visita relacionados con insurance
            optionsTypeVisit.value = filterInsuranceVisitTypes(data)
          })
        }, 400)
      }
    }
    const searchTypeConsult = (name, loading) => {
      if (name.length) {
        const datos = {
          name,
        }
        loading(true)
        clearTimeout(clearTimeoutBuscador.value)
        clearTimeoutBuscador.value = setTimeout(() => {
          axiosC.consultFilter(10, datos).then(({ data }) => {
            loading(false)
            optionsTypeConsult.value = data
          })
        }, 400)
      }
    }

    const loading = ref(false)

    const onSubmit = async () => {
      loading.value = true

      // Determine the final reason_visit value
      let finalReasonVisit = stateData.value.reason_visit
      if (stateData.value.reason_visit === 'Other' && stateData.value.reason_visit_other) {
        finalReasonVisit = stateData.value.reason_visit_other
      }

      // Create a copy of stateData without reason_visit_other
      const { reason_visit_other: _, ...stateDataWithoutOther } = stateData.value

      // Preparar datos del insurance - siempre se envían al backend
      const insuranceData = {
        nameInsuranceId: stateData.value.nameInsuranceId || null,
        copay: Number(stateData.value.copay) || 0,
        co_insurance: Number(stateData.value.co_insurance) || 0,
        deducible: Number(stateData.value.deducible) || 0,
        out_pocket: Number(stateData.value.out_pocket) || 0,
      }

      // Console log para ver qué datos se están enviando
      console.log('=== Datos que se enviarán al backend ===')
      console.log('Insurance Data:', insuranceData)
      console.log('stateData completo:', stateData.value)
      console.log('========================================')

      const baseData = {
        membership_id: stateData.value.typeVisit == 8 ? stateData.value.membership_id : null,
        cupon: stateData.value.cupon,
        user_type: 'established',
        patients_id: props.userAppointment?.id || null,
        type_visits_id: stateData.value.typeVisit,
        codeQr: stateData.value.codeQr,
        queryType: 'NC',
        user_references_id: stateData.value.user_references_id,
        type_membership: 'NC',
        reason_visit: finalReasonVisit,
        agent_insurance_id: stateData.value.agent_insurance_id,
        cities_id: stateData.value.cities_id,
        zip_codes_id: stateData.value.zip_codes_id,
        ...insuranceData,
      }

      // Crear objeto final sin reason_visit_other
      const datos = {
        ...baseData,
        ...stateDataWithoutOther,
      }

      // Modal de confirmación comentado - guarda directamente
      // pendingAppointment.value = datos
      // showConfirmation.value = true

      try {
        const res = await axiosA.appointmentCreate(datos)
        const { type, message } = notificationCheck(res)
        emit('createAppointment', {
          type,
          message,
        })
        resetstateData()
      } catch (error) {
        const { type, message } = notificationCheck(error?.response || error)
        emit('createAppointment', {
          type,
          message,
        })
      } finally {
        loading.value = false
      }
    }

    const confirmSave = async () => {
      if (!pendingAppointment.value) {
        return
      }

      loading.value = true

      try {
        const res = await axiosA.appointmentCreate(pendingAppointment.value)
        const { type, message } = notificationCheck(res)
        emit('createAppointment', {
          type,
          message,
        })
        resetstateData()
      } catch (error) {
        const { type, message } = notificationCheck(error?.response || error)
        emit('createAppointment', {
          type,
          message,
        })
      } finally {
        loading.value = false
        showConfirmation.value = false
        pendingAppointment.value = null
      }
    }

    const cancelConfirmation = () => {
      showConfirmation.value = false
      pendingAppointment.value = null
    }

    const loadReferencesList = () => {
      axiosP.referencePagination(10, 1).then(({ data }) => {
        optionsReferenceList.value = data.data
      })
    }

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetstateData)
    const config = {
      altFormat: 'F j, Y',
      dateFormat: 'Y-m-d',
      static: true,
    }
    const cancelCupon = () => {
      stateData.value.cupon = ''
    }

    const clearOtherReason = () => {
      if (stateData.value.reason_visit !== 'Other') {
        stateData.value.reason_visit_other = ''
      }
    }
    return {
      loading,
      stateData,
      optionsTypeVisit,
      optionsTypeConsult,
      toast,
      checkCodeQr,
      scanPromotion,
      isAddNewConsultSidebarActive,
      createConsult,
      searchTypeConsult,
      searchTypeVisit,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      config,
      cancelCupon,
      optionsReferenceList,
      optionsNameInsurance,
      optionsAgentInsurance,
      cityName,
      cityOptions,
      searchCitiesFromInput,
      onCitySelect,
      selectCityOption,
      isInsurance,
      isNewConsultation,
      IsInsuranceMetod,
      showOtherReasonInput,
      showConfirmation,
      confirmationMessage,
      confirmSave,
      cancelConfirmation,
      memberIdMaxLength,
      memberIdLength,
      memberIdRemaining,
    }
  },
}
</script>

<style lang="scss" scoped>
.button-custom {
  padding: 5px !important;
}

.city-autocomplete-wrap {
  position: relative;
}

.city-options-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e1e5e9;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-top: 2px;
}

.city-option-item {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.15s ease;
}

.city-option-item:hover {
  background-color: #f8f9fa;
}

.city-option-item:last-child {
  border-bottom: none;
}
</style>
